export function toSnakeCase(title: string) {
    return title.replace(/[^a-z0-9]/gi, '_').toLowerCase();
}
